import React, { useState, useEffect } from 'react';
import { PageTemplate, Card, Button } from '../components/ui';
import MasterScheduleCalendar from '../components/MasterScheduleCalendar';
import { useAuth } from '../contexts/AuthContext';

const ScheduleView = () => {
    const { currentUser } = useAuth();

    useEffect(() => {
        if (currentUser && currentUser.User_Role !== 'ATL_ADMIN') {
            window.location.replace('/');
        }
    }, [currentUser]);
    const [resourceType, setResourceType] = useState('equipment'); // 'equipment' or 'venue'

    return (
        <PageTemplate
            title="Master Schedule"
            subtitle="View all bookings across equipment and venues"
        >
            <div className="space-y-6">
                <Card>
                    <Card.Content>
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div>
                                <label className="block text-sm font-serif font-medium text-primary-700 dark:text-gray-300 mb-2">
                                    Resource Type
                                </label>
                                <div className="flex gap-2">
                                    <Button
                                        variant={resourceType === 'equipment' ? 'primary' : 'secondary'}
                                        size="sm"
                                        onClick={() => setResourceType('equipment')}
                                    >
                                        Equipment
                                    </Button>
                                    <Button
                                        variant={resourceType === 'venue' ? 'primary' : 'secondary'}
                                        size="sm"
                                        onClick={() => setResourceType('venue')}
                                    >
                                        Venues
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card.Content>
                </Card>

                <div>
                    <MasterScheduleCalendar type={resourceType} />

                    <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                        <h4 className="text-sm font-serif font-semibold text-blue-900 dark:text-blue-300 mb-2">
                            How to Use This Calendar
                        </h4>
                        <ul className="text-sm text-blue-800 dark:text-blue-300 space-y-1 list-disc list-inside">
                            <li><strong>Color coding</strong>: Yellow = Pending, Green = Confirmed, Gray = Completed</li>
                            <li><strong>Day/Week</strong>: Switch between single day or full week view</li>
                            <li><strong>Navigation</strong>: Use arrows or &quot;Today&quot; to change dates</li>
                            <li>
                                <strong>Full booking form</strong>: Click any coloured booking cell to open borrower
                                details and everything submitted on the booking form (contact, affiliation, course
                                code, remarks, etc.)
                            </li>
                            <li><strong>Weekends</strong>: Grayed out for equipment (no weekend loans)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </PageTemplate>
    );
};

export default ScheduleView;
